module.exports = __webpack_public_path__ + "assets/webgl/card_083_EN_L0.jpg.fcd90d3f.webp";